import { render, staticRenderFns } from "./Decoration3.vue?vue&type=template&id=3fa05d52&scoped=true"
import script from "./Decoration3.vue?vue&type=script&lang=js"
export * from "./Decoration3.vue?vue&type=script&lang=js"
import style0 from "./Decoration3.vue?vue&type=style&index=0&id=3fa05d52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa05d52",
  null
  
)

export default component.exports